'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = {
    FETCH_ANNOUNCEMENTS_REQUEST: 'FETCH_ANNOUNCEMENTS_REQUEST',
    FETCH_ANNOUNCEMENTS_SUCCEEDED: 'FETCH_ANNOUNCEMENTS_SUCCEEDED',
    FETCH_ANNOUNCEMENTS_FAILED: 'FETCH_ANNOUNCEMENTS_FAILED'
};

function fetchAnnouncementsRequest() {
    return {
        type: actionTypes.FETCH_ANNOUNCEMENTS_REQUEST
    };
}

function fetchAnnouncementsSucceeded(announcements) {
    return {
        type: actionTypes.FETCH_ANNOUNCEMENTS_SUCCEEDED,
        announcements: announcements
    };
}

function fetchAnnouncementsFailed() {
    return {
        type: actionTypes.FETCH_ANNOUNCEMENTS_FAILED
    };
}

var actionCreators = {
    fetchAnnouncementsRequest: fetchAnnouncementsRequest,
    fetchAnnouncementsSucceeded: fetchAnnouncementsSucceeded,
    fetchAnnouncementsFailed: fetchAnnouncementsFailed
};

exports.actionTypes = actionTypes;
exports.actionCreators = actionCreators;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/actions/announcements.js
// module id = 260
// module chunks = 0